import { BodyXS } from '@/components/atomic/text'
import { cn } from '@/utils/shadcn/utils'

export const ModeToggleContainer = ({
  children,
}: {
  children: React.ReactNode
}) => <div className="flex items-center gap-2 mb-4 pb-3">{children}</div>

export const RowLabel = ({
  className,
  children,
}: {
  className?: string
  children: React.ReactNode
}) => {
  return (
    <BodyXS
      className={cn(
        'min-w-[52px] text-moment-blue-grey-800 dark:text-moment-blue-grey-400',
        className,
      )}
    >
      {children}
    </BodyXS>
  )
}

export const TierRow = ({ children }: { children: React.ReactNode }) => (
  <div className="flex gap-3 items-center w-full py-2">{children}</div>
)

export const TiersContainer = ({ children }: { children: React.ReactNode }) => (
  <div className="flex flex-col">{children}</div>
)

export const TierInputContainer = ({
  children,
}: {
  children: React.ReactNode
}) => <div className="flex items-center gap-2 w-full">{children}</div>

export const SliderWrapper = ({ children }: { children: React.ReactNode }) => (
  <div className="flex-1 min-w-0">{children}</div>
)
